import React from 'react'
import ErrorBoundary from './ErrorBoundary';
import Popup from './Popup';
import HubInput from './HubInput'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import NotePopup from './NotePopup';
import db from './db';
import FacilityPopup from './FacilityPopup.js';
import BeaconHistoryPopup from './BeaconHistoryPopup';
import Cookies from 'universal-cookie';
import WarningTable from './WarningTable';
import Dropdown from 'react-dropdown';
import HubInstructions from './HubInstructions';
import HubTestPopup from './HubTestPopup';
import HubSettingsPopup from './HubSettingsPopup';
import DiffViewer from "./DiffViewer";
import DiffStandardFile from './../DiffStandardFile';
import FactoryDevices from "./FactoryDevices";
import BarCodePopupButton from "./BarCodePopupButton"
import SearchPopupButton from "./SearchPopupButton"
import ExecuteScriptPopupButton from "./ExecuteScriptPopupButton"
import CradlepointRouterTable from "./CradlepointRouterTable"
import OrderAllTable from "./OrderAllTable.js";
var functions = require("./functions.js");
var hubErrors = require("./HubErrors.js");
var tableColumnRender = require("./TableColumnRender.js")

let thisApp=undefined;
const emptyHub={id:-1,notes:[],suggestions:[],lastPing:{time:"unk"}};
const emptyHubDataNote=
    {
        note_date:"",
        data:"",
        json:{ headsets:[],bracelets:[],toddles:[]
            ,sysinfo:{node_env:"",git_hash:"",git_date:"",git_branch:"",version:"",external_ip:""} 
            ,sshdata:{data:""}
        }
    };
const emptyHubData=
    { headsets:[],bracelets:[],toddles:[]
        ,sysinfo:{node_env:"",git_hash:"",git_date:"",git_branch:"",version:"",external_ip:""} 
        ,sshdata:{data:""}
    };
var hubTabDataHeight="75vh";
if(window.innerHeight<600 || window.innerWidth<600){
    hubTabDataHeight="40vh";
}
//const hubTabDataHeightLess="65vh";

// FacilityPopup Component
export default class HubPopup extends React.Component {

    newHubId=-1;
    headsetType=0;
    toddleType=1;
    braceletType=2;
    didMount=false;
    cookies = new Cookies();

    constructor(props) {
        super(props);
        let commandOption="cloud";
        this.state = {
            hubId:this.newHubId,
            hub:Object.assign({}, emptyHub),
            hubPopupData:Object.assign({}, emptyHub),
            hubPopupDataNote:Object.assign({}, emptyHubDataNote),
            hubPopupDataPosition:this.newHubId,
            hubPopupDataList:[],
            hubPopupDataSettings:[],
            hubPopupVisible:false,
            hubPopupModified : false,
            hubPopupPost:Object.assign({}, emptyHub),
            hubErrors:hubErrors.getEmptyHubErrors(),
            hubNote:Object.assign({}, NotePopup.emptyNote),
            hubNoteVisible:false,
            beaconPair:undefined,
            hubTest:undefined,
            commandOption:commandOption,
            key: Date.now(),
            notesDisplay:[],
            hubSetting:{},
            hubSettingVisible:false,
            diffFileTxt:"",
            factoryDevicesPopupVisible:false,
            facilityPopupId:undefined,
            yolinkNote:"",
            iframeHeight:window.screen.height - 120,
            remoteAccessUrl:undefined,
            test_instance_count:1
        }
        this.updateDimensions();
      }
  
      updateDimensions = () => {
        let commandOption="cloud";
        if(functions.isMobile()){
            commandOption="none";
        }
        this.setState({ commandOption: commandOption });
      };
      componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.didMount=true;
      }
      componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
      }      
    // if the hub changes then change properties
    componentDidUpdate(prevProps) {
        if (
            ( this.didMount
                && this.props.hubId
                && this.state.hub
                && this.props.hubId!==this.state.hub.id
                && this.props.visible
            )

         ) {
             this.loadData();
            //alert(JSON.stringify(DiffStandardFile()[0].text)); // "some sample text" 
        }
    }

    getArrayLength(arr){
        let res=0;
        try{
            res=arr.length;
        } catch {
        }
        return res;
    }
    loadData(refreshScreen){
        try {
            
            if(!this.props.hubId){
                //alert(`unable to load hub ${this.props.hubId} please try again`);
                this.closeHub();
                return;
            }
            db.getHub(this.props.hubId, this.props.securityObject, (hub)=>{
                if(hub){
//                console.log(JSON.stringify(hub,null,2))
                this.setState(
                    {hub:hub}
                );

                let yolinkNoteText="";
                if(hub.facilityNotes){
                    hub.facilityNotes.forEach((note)=>{
                        if(note.note_type==='acc-YoLink'){
                            yolinkNoteText+=note.note+"\n";
                        }

                    });
                }
                this.setState({yolinkNote:yolinkNoteText});

                // get the hubPopupDataList
                let hubPopupDataList =[];
                this.state.hub.notes.forEach(note => {
                    if(note.note_type==='sys_json'){
                        let json=[];
                        try{
                            json=JSON.parse(note.note);
                        } catch(e) {
                            json=Object.assign({}, emptyHubData);
                        }
                        note.json=json;
                        hubPopupDataList.push(note);
                    }
                });

                this.setState({
                    hubPopupVisible:true,
                    hubPopupDataPosition:0,
                    hubErrors:hubErrors.getEmptyHubErrors(),
                    hubPopupDataList:hubPopupDataList,
                    hubId:this.state.hub.id
                })            
                this.updateNoteTypeInputValue();
                this.changeHubData( 0
                                    , this.state.hub
                                    , hubPopupDataList );
                                    
                //if(refreshScreen){
                //    this.setState({
                //        key: Date.now()
                //    })            
        
                //}
                }                   
            });
        } catch(e){
            window.alert(e);
        }
    }
    changeHubData(inc, hubPopupData, hubPopupDataList){

        if(!hubPopupData){
            hubPopupData=this.state.hubPopupData;
        }
        if(!hubPopupDataList){
            hubPopupDataList=this.state.hubPopupDataList;
        }
        let hubDataNote=Object.assign({}, emptyHubDataNote);;
        let hubPopupDataSettings=[];
        let hubPopupDataPosition=inc;
        if(inc!==0){
            hubPopupDataPosition = this.state.hubPopupDataPosition+inc;
        }
        if(hubPopupDataList.length===0){
            
        } else if(hubPopupDataPosition<0){
            window.alert("this is the first hub data");
            return;
        }
        else if(hubPopupDataPosition>hubPopupDataList.length){
            window.alert("this is the last hub data");
            return;
        } else {
            hubDataNote=hubPopupDataList[hubPopupDataPosition];
    
            // clean up if there is missing data
            if(!hubDataNote.json){
                hubDataNote.json={};
            }
            if(!hubDataNote.json.headsets){
                hubDataNote.json.headsets=[];
            }
            if(!hubDataNote.json.bracelets){
                hubDataNote.json.bracelets=[];
            }
            if(!hubDataNote.json.lifeguardTags){
                hubDataNote.json.lifeguardTags=[];
            }
            if(!this.getBuddieTagList()){
                hubDataNote.json.toddles=[];
            }                        
            if(!hubDataNote.json.sshdata){
                hubDataNote.json.sshdata={data:""};
            }
            if(!hubDataNote.json.settings){
                hubDataNote.json.settings=[];
            }
            try{
                Object.keys(hubDataNote.json.settings).map((key) => hubDataNote.json.settings[key].key=key);
                hubPopupDataSettings= Object.keys(hubDataNote.json.settings).map((key) => hubDataNote.json.settings[key]);    
            } catch (e){
                window.alert(e);
            }
        }
        // find errors
        //let suggestionRules=[];
        //db.getSystemSettings( this.props.securityObject
        //    , async results =>{
                //suggestionRules = JSON.parse(this.props.securityObject.systemSettings["hub_rules"]);

                let hubErr=hubErrors.getHubErrors( //suggestionRules,
                    this.state.hub.major
                    , hubPopupData
                    , hubDataNote);
                this.setState({
                    hubPopupDataNote:hubDataNote,
                    hubPopupDataPosition:hubPopupDataPosition,
                    hubPopupDataSettings:hubPopupDataSettings,
                    hubErrors:hubErr
                });                   
            //}
        //);
                    


    }

    // render
    render() {
        if(!this.state.hub){
            return "";
        }
        let facilityNameOfImportantHubColor="hub-important";
        if(this.state.hub.facility_type!=="commercial" && this.state.hub.facility_type!=="consumer" ){
            facilityNameOfImportantHubColor="hub-unimportant";
        }
        let warningsToTracktHubColor="hub-important";
        if(this.state.hub.send_warnings_to_slack!=="Y"){
            warningsToTracktHubColor="hub-unimportant";
        }
        let noteTypeList=[];
        try{ 
            noteTypeList=JSON.parse(this.props.securityObject.systemSettings.note_type_list );
        } catch (ex){

        }
        let accessoriesCount=0;
        try{
            accessoriesCount=this.state.hubPopupDataNote.json.accessories.length
        } catch (ex){

        }
        let grafanalink=`https://dashboard.wavedds.net/d/eHZy6-1Ik/individual-hub-status?var-hub=${this.state.hub.hostname}`;
        let hideTabsClassname=undefined;
        if(functions.isMobile()){
            hideTabsClassname="hidden";
        }
        return(this.state.hub) ? (
            <Popup className="facility-popup" trigger={ this.props.visible } key={this.state.key} >
                <Popup trigger={this.state.remoteAccessUrl}> 
                    <div className="align-right">
                    <button className="mobileHide" 
                        onClick={() => this.setState({remoteAccessUrl:undefined}) }>x</button>
                    </div>
                    <iframe width="95%" height="600px" src={this.state.remoteAccessUrl}  />
                </Popup>
                <h3>
                    { this.state.hub.facility_id} - { this.state.hub.facility_name} / { this.state.hub.id} - { this.state.hub.hostname}
                    { functions.showModified(this.state.hubPopupModified) }
                    <div className="align-right">
                        <small><span className="mobileHide">Last Grafana </span>Ping:<span dangerouslySetInnerHTML={ { __html:functions.colorFormatDateTime(this.state.hub.lastPing.time,this.state.hub.server_time,this.state.hub.minutes_not_connected_then_offline-1,this.state.hub.minutes_not_connected_then_offline)}}></span></small>
                        <small><span className="mobileHide"> First Ping at:</span> {this.state.hub.lastPing.location_city_state}:<span dangerouslySetInnerHTML={ { __html:functions.colorFormatDateTime(this.state.hub.first_ping_for_external_ip,this.state.hub.server_time,9999999,9999999)}}></span></small>
                        <button hidden={this.state.hubPopupDataList.length===0 || this.state.hubPopupDataPosition===0} className="" onClick={() => this.changeHubData(-1)  }>&larr;</button>
                        &nbsp;
                        <small><span className="mobileHide">Last Device App </span>Update:<span dangerouslySetInnerHTML={ { __html: functions.colorFormatDateTime(this.state.hub.script_last_run,this.state.hub.server_time,24*60*7,24*60*10)}}></span></small>
                        &nbsp;
                        <span className="mobileHide">
                            <button hidden={this.state.hubPopupDataList.length===0  || this.state.hubPopupDataPosition===this.state.hubPopupDataList.length-1 } className="" onClick={() => this.changeHubData(+1)  }>&rarr;</button>
                            &nbsp;
                            <button onClick={()=>this.loadData(true)}>refresh</button>
                            &nbsp;
                            <button hidden={this.state.hubPopupDataList.length===0} className="" onClick={() => this.downloadHubData(this.state.hubPopupDataNote)  }>&darr;</button>
                            &nbsp;
                        </span>
                        <select className="mobileHide" id="selectCommandOption"
                            onChange={this.updateCommandOption.bind(this)} >
                            <option value="cloud">cloud (AWS Bastion Host Gateway)</option>
                            <option value="pep">Cell Router ({this.state.hub.cell_device_ssid})</option>
                            <option value="dns">{this.state.hub.hostname}.hub.wavedds.net (Wave Demo)</option>
                            <option value="ip">{this.state.hub.processor_ip_address} (Wave Demo)</option>
                        </select>
                        &nbsp;
                        <span className="mobileHide">
                            <button onClick={()=>{this.exportHubLabelCsv()}} >Export Labels CSV</button>
                            &nbsp;
                        </span>
                        <button className="mobileHide" onClick={() => this.closeHub() }>x</button>
                        <div className="" id="divCommandOptionIP" hidden={this.state.commandOption!=="ip"}>
                            <button alt='ssh' className="" title="Password will be copied to clipboard" onClick={() => functions.openWindow( this.getSSHUrl(this.state.hub.processor_ip_address, this.state.hub.processor_user) ) }>SSH<img alt='ssh' height="15px" src="icons8-clone-figure-32.png"></img></button>
                            &nbsp;
                            <button className="" onClick={() => functions.openWindow( this.getHmpUrl(this.state.hub.processor_ip_address) ) }>HMP App</button>
                            &nbsp;
                            <button className="" onClick={() => functions.openWindow( this.getHmpUrl(this.state.hub.processor_ip_address)+"/api/doc" ) }>api</button>
                        </div>
                        <div className="" id="divCommandOptionDNS" hidden={this.state.commandOption!=="dns"} >
                            <button className="" title="Password will be copied to clipboard" onClick={() => functions.openWindow( this.getSSHUrl(this.state.hub.hostname+".hub.wavedds.net", this.state.hub.processor_user) ) }>SSH<img alt='ssh' height="15px" src="icons8-clone-figure-32.png"></img></button>
                            &nbsp;
                            <button className="" onClick={() => functions.openWindow( this.getHmpUrl(this.state.hub.hostname+".hub.wavedds.net") ) }>HMP App</button>
                            &nbsp;
                            <button className="" onClick={() => functions.openWindow( this.getHmpUrl(this.state.hub.hostname+".hub.wavedds.net")+"/api/doc" ) }>api</button>
                        </div>

                        <div className="" id="divCommandOptionPepWave" hidden={this.state.commandOption!=="pep"} >
                            <button className="" title="Password will be copied to clipboard" onClick={() => functions.openWindow( this.getSSHUrl( "192.168.13.100" , this.state.hub.processor_user) ) }>SSH<img alt='ssh' height="15px" src="icons8-clone-figure-32.png"></img></button>
                            &nbsp;
                            <button className="" onClick={() => functions.openWindow( this.getHmpUrl("192.168.13.100") ) }>HMP App</button>
                            &nbsp;
                            <button className="" onClick={() => functions.openWindow( "http://192.168.13.31" ) }>Cell Router</button>
                        </div>

                        <div className="" id="divCommandOptionCloud"  hidden={this.state.commandOption!=="cloud"}>
                            <button className="" title="command to connect to hub from AWS Bastion Host Gateway will be put into clipboard" onClick={() => functions.openWindow( functions.getSSHUrlForGateway(this.state.hub.hostname+".hubs.wavedds.com", this.state.hub.processor_user) ) }>AWS<span className="mobileHide"> Bastion Host Gateway</span><img alt='Gateway' height="15px" src="icons8-clone-figure-32.png"></img></button>
                            &nbsp;
                            <span className='box'>
                                <small>Proxy</small> <input id='proxyPort' style={ {width:50} } onChange={this.updateProxyPort.bind(this)} defaultValue={this.getDefaultProxyPort()}></input>
                                <button className="" onClick={() => this.proxyNew() } title="Commands to manually set up the tunnel">New</button>
                                &nbsp;
                                <button className="" onClick={() => this.proxyCmd() } title="Commands to manually set up the tunnel">Command</button>
                                &nbsp;
                                <button className="" onClick={() => functions.openWindow(this.startProxy()) }>Start</button>
                                &nbsp;
                                <button className="" onClick={() => functions.openWindow(`proxybrowser://${this.state.hub.hostname}.hub.wavedds.net:${this.state.hub.processor_app_port}/`) }>HMP DNS</button>
                                &nbsp;
                                <button className="" onClick={() => functions.openWindow(`proxybrowser://192.168.13.100:${this.state.hub.processor_app_port}/`) }>HMP IP</button>
                                &nbsp;
                                <button className="" onClick={() => functions.openWindow("proxybrowser://192.168.13.50") }>Cassia</button>
                                &nbsp;
                                <button className="" onClick={() => functions.openWindow("proxybrowser://192.168.13.31/") }>Cell Router</button>
                                &nbsp;
                                <button className="" onClick={() => functions.openWindow("proxybrowser://192.168.13.31:9191") }>LX-40</button>
                                &nbsp;
                                <button className="" onClick={() => functions.openWindow(this.stopProxy()) }>Stop</button>
                                &nbsp;
                                <button className="" title="view instructions for setting up proxy" onClick={() => functions.openWindow("https://sites.google.com/wavedds.com/internal/archive/wave-product-inventory-app") }>Instructions</button>
                                &nbsp;
                                <button className="" onClick={() => functions.openWindow( `proxybrowser://192.168.13.100:${this.state.hub.processor_app_port}/api/doc/`) }>api</button>
                            </span>
                        </div>
                        <ExecuteScriptPopupButton
                                disabled={this.state.hubPopupModified}
                                securityObject={this.props.securityObject}
                                buttonLabel="Update Device App with Hub Data"
                                screenLabel="Executing Hub Data Update..."
                                onClose={()=>this.loadData(true)}
                                url={`api/processUpdateHub?hostname=${this.state.hub.hostname}&user=${this.state.hub.processor_user}&port=${this.state.hub.processor_app_port}`}
                            >
                        </ExecuteScriptPopupButton>
                        &nbsp;
                        <button className="mobileShow" onClick={() => this.closeHub() }>x</button>
                        &nbsp;
                        <button className="mobileHide" title="Program Wearables" onClick={() => functions.openWindow(functions.getSSHUrlForBeaconConfig() ) }>Program Wearables</button>
                        &nbsp;
                        <button className="mobileHide" onClick={() => functions.openInstructionBook() }>Instruction Book</button>
                        &nbsp;
                        <button className="mobileHide" onClick={() => functions.openWindow( "https://drive.google.com/drive/folders/1xnhWZpVW5_vzPqoKBBWxg_Oc_1NA-GVm" ) }>Files</button>
                        &nbsp;
                        <button className="mobileHide" onClick={() => functions.openWindow( "https://katanamrp.com/login/" ) }>Katana</button>
                        &nbsp;
                        <button className="mobileHide" onClick={() => functions.openWindow( `https://dashboard.wavedds.net/d/eHZy6-1Ik/individual-hub-status?var-hub=${this.state.hub.hostname}` ) }>Grafana</button>
                        &nbsp;
                    </div>
                </h3>
                <Tabs defaultIndex={this.props.tabIndex} >
                    <TabList>
                        <Tab disabled={this.state.hubPopupModified}>Hub</Tab>
                        <Tab disabled={this.state.hubPopupModified}>Provision</Tab>
                        <Tab disabled={this.state.hubPopupModified} >Notes</Tab>
                        <Tab disabled={this.state.hubPopupModified} >Accessories ({accessoriesCount})</Tab>
                        <Tab disabled={this.state.hubPopupModified || !this.state.hubPopupDataNote.json} >
                            Swimmer ({this.state.hubPopupDataNote.json.headsets.length} / 
                            <span className="bad-battery">{this.state.hubErrors.badTrackerCount}</span>)
                        </Tab>
                        <Tab disabled={this.state.hubPopupModified || !this.state.hubPopupDataNote.json} >
                            Buddy 
                            ({this.getBuddieTagList().length} / 
                            <span className="bad-battery">{this.state.hubErrors.badToddleCount}</span>)
                        </Tab>
                        <Tab disabled={this.state.hubPopupModified || !this.state.hubPopupDataNote} >
                            Bracelet 
                            ({this.state.hubPopupDataNote.json.bracelets.length} / 
                            <span className="bad-battery">{this.state.hubErrors.badBraceletCount}</span>)
                        </Tab>
                        <Tab disabled={this.state.hubPopupModified || !this.state.hubPopupDataNote} >
                            Lifeguard
                            ({this.getArrayLength(this.state.hubPopupDataNote.json.lifeguardTags)} / 
                            <span className="bad-battery">{this.state.hubErrors.badLifeguardTagCount}</span>)
                        </Tab>
                        <Tab disabled={this.state.hubPopupModified || !this.state.hubPopupDataNote} >SysInfo</Tab>
                        <Tab disabled={this.state.hubPopupModified || !this.state.hubPopupDataNote} >Settings</Tab>
                    </TabList>                    
                    <TabPanel >
                        <div style={{height:hubTabDataHeight}}>
                            <ErrorBoundary>
                                <div>
                                    <button  disabled={!this.state.hubPopupModified} className="" onClick={() => this.closeHub() }>Close</button>
                                    <button  disabled={!this.state.hubPopupModified} className="" onClick={() => this.saveHub() }>Save</button>
                                </div>
                                <div id="hub-data" style={{height:hubTabDataHeight, width:"850px" }} className="float-left-scroll" >
                                    <h3>
                                        { this.state.errorMessage}
                                    </h3>
                                    <label>id</label>{this.state.hub.id}
                                    <HubInput owner={this} dbColumn='hostname' disabled></HubInput>
                                    <HubInput owner={this} dbColumn='name' disabled display_as="name on hub maintenance page"></HubInput>
                                    <HubInput owner={this} dbColumn='wave_name' display_as="pool name"></HubInput> If "pool name" is empty "name on hub maintenance page" will be displayed in reports<br></br>
                                    <label>organization</label>
                                    {this.state.hub.organization_id} {this.state.hub.organization_name} ({this.state.hub.company_profile})
                                    &nbsp;
                                    <button onClick={()=>functions.openHubspotCompany(this.state.hub.hubspot_parent_company_id  )}>HubSpot</button>
                                    <br />
                                    <label>facility</label>
                                    {this.state.hub.facility_id} {this.state.hub.facility_name}
                                    <button onClick={()=>this.viewFacility()}>View Facility</button>
                                    &nbsp;
                                    <button onClick={()=>functions.openHubspotCompany(this.state.hub.hubspot_company_id )}>HubSpot</button>
                                    <br />
                                    <b>Move To:</b>
                                    &nbsp;
                                    <button disabled={this.state.hubPopupModified} onClick={() => this.moveCurrentFacility(FacilityPopup.inventoryFacilityId,"Inventory") }>Inventory</button>
                                    &nbsp;
                                    <button disabled={this.state.hubPopupModified} onClick={() => this.moveCurrentFacility(FacilityPopup.retiredFacilityId,"Retired") }>Retired</button>
                                    &nbsp;
                                    <button disabled={this.state.hubPopupModified} onClick={() => this.moveCurrentFacility(FacilityPopup.needToBeFixedFacilityId,"Need To Be Fixed") }>Need To Be Fixed</button>                                                
                                    &nbsp;
                                    <button disabled={this.state.hubPopupModified} onClick={() => this.moveCurrentFacility(FacilityPopup.boardInventoryFacilityId,"Board Inventory") }>Board Inventory</button>
                                    &nbsp;
                                    <SearchPopupButton
                                            disabled={this.state.hubPopupModified}
                                            securityObject={this.props.securityObject}
                                            buttonLabel="Select Facility"
                                            query={this.props.securityObject.httpServer + "api/get/facilitySearch?"}
                                            columns={[
                                                    { key: 'id', title:"Facility id", width :20, noquery:true }
                                                    ,{ key: 'display_facility_name', title:"facility name", width :40, noquery:true }
                                                    ,{ key: 'display_address', title:"facility address", width :40, noquery:true }
                                                    ,{ key: 'display_city', title:"city", width :40, noquery:true }
                                                    ,{ key: 'display_state', title:"state", width :40, noquery:true }
                                                    ,{ key: 'display_zip', title:"zip", width :40, noquery:true }
                                                    ,{ key: 'search_column', title:"Search", width :40 }
                                                    ]}
                                            onClick={this.moveFacility.bind(this)}
                                        >
                                    </SearchPopupButton>
                                    <br />
                                    <div>
                                        <fieldset>
                                            <legend >Hub Info</legend>
                                            <HubInput owner={this} dbColumn='status_code' ></HubInput>
                                            <HubInput owner={this} dbColumn='status_note' ></HubInput>
                                            <HubInput owner={this} dbColumn='active_ticket_number' >(link to hubspot or other)</HubInput> 
                                            <HubInput owner={this} dbColumn='model' ></HubInput>
                                            <HubInput owner={this} dbColumn='wave_v2_version' ></HubInput>
                                            <HubInput owner={this} dbColumn='env_model' ></HubInput>
                                            <HubInput owner={this} dbColumn='number_of_batteries' type='number'></HubInput>
                                            <HubInput owner={this} dbColumn='env_build_type' ></HubInput>
                                            <HubInput owner={this} dbColumn='water_type'></HubInput>
                                            <HubInput owner={this} dbColumn='run_script_hourly'></HubInput>
                                            <HubInput owner={this} dbColumn='max_hub_alert_id_processed' type='number'></HubInput>
                                        </fieldset>
                                    </div>
                                    <div >
                                        <fieldset>
                                            <legend >yolink</legend>
                                            <HubInput owner={this} dbColumn='yolink_serial_number' ></HubInput>
                                            <BarCodePopupButton key="barcodeYolinkSerialNumber"
                                                defaultValue={this.state.hub.yolink_serial_number}
                                                title="YoLink Serial Number">
                                            </BarCodePopupButton>
                                            <BarCodePopupButton key="barcodeYolinkNote"
                                                defaultValue={this.state.yolinkNote}
                                                >
                                            </BarCodePopupButton>
                                        </fieldset>
                                    </div>
                                     <div>
                                        <fieldset>
                                            <legend >Processor (pi/nanopi)</legend>
                                            <HubInput owner={this} dbColumn='processor_ip_address' ><button onClick={()=>this.ipLookup()}>IP Lookup</button></HubInput>
                                            <HubInput owner={this} dbColumn='processor_ethernet_mac' ></HubInput>
                                            <HubInput owner={this} dbColumn='processor_wifi_mac' ></HubInput>
                                            <HubInput owner={this} dbColumn='processor_description' ></HubInput>
                                            <HubInput owner={this} dbColumn='processor_app_port' ></HubInput>
                                            <HubInput owner={this} dbColumn='processor_user' ></HubInput>
                                            <HubInput owner={this} dbColumn='processor_password' ></HubInput>
                                            <HubInput owner={this} dbColumn='processor_password_removed' ></HubInput>
                                            <HubInput owner={this} dbColumn='disk_space_total_in_mb'  type='number' ></HubInput>
                                            <HubInput owner={this} dbColumn='disk_space_available_in_mb' type='number' ></HubInput>
                                            <HubInput owner={this} dbColumn='python_version' ></HubInput>
                                            <HubInput owner={this} dbColumn='node_version' ></HubInput>
                                            <HubInput owner={this} dbColumn='i2c_68' ></HubInput>
                                        </fieldset>
                                    </div>
                                    <div>
                                        <fieldset>
                                            <legend >WiFi (pi/nanopi)</legend>
                                            <HubInput owner={this} dbColumn='wifi_local_on' ></HubInput>
                                            <HubInput owner={this} dbColumn='wifi_local_ssid' ></HubInput>
                                            <HubInput owner={this} dbColumn='wifi_local_ssid_password' ></HubInput>
                                        </fieldset>
                                    </div>
                                    <div >
                                        <fieldset>
                                            <legend >Cellular (Cradlepoint/Pepwave/Sieara Wireless)</legend>
                                            <CradlepointRouterTable
                                                securityObject={this.props.securityObject}
                                                cradlepointSerialNumber={this.state.hub.cell_device_serial_number}
                                            ></CradlepointRouterTable>
                                            <HubInput owner={this} dbColumn='cell_device_serial_number' ></HubInput>
                                            <HubInput owner={this} dbColumn='cell_wifi_facility_ssid' ></HubInput>
                                            <HubInput owner={this} dbColumn='cell_wifi_facility_password' type="password" >
                                                <button onClick={this.toggleinputcell_wifi_facility_password}>View/Hide</button>
                                                <button onClick={this.decodeinputcell_wifi_facility_password.bind(this)}>Decode</button>
                                                <ExecuteScriptPopupButton
                                                    disabled={this.state.hubPopupModified}
                                                    securityObject={this.props.securityObject}
                                                    buttonLabel="Updating facility wifi on cellular router"
                                                    screenLabel="Updating facility wifi on cellular router ..."
                                                    onClose={()=>this.loadData(true)}
                                                    url={`api/updateFacilityWiFiOnCellRouter?hostname=${this.state.hub.hostname}&user=${this.state.hub.processor_user}&port=${this.state.hub.processor_app_port}`}
                                                ></ExecuteScriptPopupButton>
                                                <ExecuteScriptPopupButton
                                                    disabled={this.state.hubPopupModified}
                                                    securityObject={this.props.securityObject}
                                                    buttonLabel="Updating cellular router data"
                                                    screenLabel="Updating cellular router data ..."
                                                    onClose={()=>this.loadData(true)}
                                                    url={`api/updateFacilityWiFiData?hostname=${this.state.hub.hostname}`}
                                                ></ExecuteScriptPopupButton>                                                
                                            </HubInput>
                                            Depricated<br />
                                            <HubInput owner={this} dbColumn='cell_wifi_switch_over' ></HubInput>
                                            <HubInput owner={this} dbColumn='cell_ether_mac' ></HubInput>
                                            <HubInput owner={this} dbColumn='cell_device_username' ></HubInput>
                                            <HubInput owner={this} dbColumn='cell_device_password' ></HubInput>
                                            <HubInput owner={this} dbColumn='cell_device_firmware_version' ></HubInput>
                                            <HubInput owner={this} dbColumn='cell_device_ssid' ></HubInput>
                                            <HubInput owner={this} dbColumn='cell_sim_vendor' ></HubInput>                               
                                            <HubInput owner={this} dbColumn='cell_sim_ICCID' ></HubInput>
                                            <HubInput owner={this} dbColumn='cell_sim_sid' ></HubInput>
                                            <HubInput owner={this} dbColumn='cell_sim_unique_name' ></HubInput>
                                            <HubInput owner={this} dbColumn='cell_wifi_password' ></HubInput>
                                        </fieldset>
                                    </div>
                                    <div>
                                        <fieldset>
                                            <legend >Bluetooth (Cassia/esp32)</legend>
                                            <HubInput owner={this} dbColumn='bluetooth_hub_serial_number' ></HubInput>
                                            <HubInput owner={this} dbColumn='bluetooth_hub_mac' ></HubInput>
                                            <HubInput owner={this} dbColumn='bluetooth_hub_model' ></HubInput>
                                            <HubInput owner={this} dbColumn='bluetooth_hub_password' ></HubInput>
                                            <HubInput owner={this} dbColumn='bluetooth_hub_firmware_version' ></HubInput>
                                        </fieldset>
                                    </div>
                                    <div>
                                        <fieldset>
                                            <legend >Misc</legend>
                                            <HubInput owner={this} dbColumn='bastion_host' ></HubInput>
                                            <HubInput owner={this} dbColumn='beacon_firmware_version' ></HubInput>
                                            <HubInput owner={this} dbColumn='script_version' ></HubInput>
                                            <HubInput owner={this} dbColumn='script_last_run' ></HubInput>
                                            <HubInput owner={this}dbColumn='icb_Number' ></HubInput>
                                            <HubInput owner={this} dbColumn='icb_version' ></HubInput>
                                            <HubInput owner={this} dbColumn='icb_date_shipped' ></HubInput>
                                            <HubInput owner={this} dbColumn='normally_plugged_in'></HubInput>
                                           <HubInput owner={this} dbColumn='power_save_status'></HubInput>
                                           <HubInput owner={this} dbColumn='which_aws'></HubInput>
                                        </fieldset>
                                    </div>
                                    <div>
                                        <fieldset>
                                            <legend >Location</legend>
                                            <label>Longitude</label>
                                            <input type="text" disabled name="longitude" defaultValue={ this.state.hubPopupData.longitude}  onChange={this.updateHubInputValue}/>
                                            <br />

                                            <label>Latitude</label>
                                            <input type="text" disabled name="latitude" defaultValue={ this.state.hubPopupData.latitude}  onChange={this.updateHubInputValue}/>
                                            <br />

                                            <label>City</label>
                                            <input type="text" disabled name="city" defaultValue={ this.state.hubPopupData.city}  onChange={this.updateHubInputValue}/>
                                            <br />

                                            <label>State</label>
                                            <input type="text" disabled name="state" defaultValue={ this.state.hubPopupData.state}  onChange={this.updateHubInputValue}/>
                                            <br />

                                            <label>Country</label>
                                            <input type="text" disabled name="country" defaultValue={ this.state.hubPopupData.country}  onChange={this.updateHubInputValue}/>
                                            <br />

                                        </fieldset>
                                    </div>
                                </div>
                                <div className="float-left-scroll ssh-data" style={{"height":hubTabDataHeight, "width":'calc(100% - 870px)' } }>
                                    <pre className="hub-errors">
                                        {this.state.hubErrors.errorMemo}
                                    </pre>
                                    <pre id="sshDisplayData">
                                                {this.state.hubPopupDataNote.json.sshdata.data}
                                    </pre>
                                </div>
                                    <div >
                                        <fieldset>
                                            <legend > Grafana Tracking (depricated)</legend>
                                            <label className="hub-input-label">{"facility_type"}</label>
                                            {this.state.hub.facility_type}
                                            <br />
                                            <HubInput owner={this} dbColumn='send_warnings_to_slack'></HubInput>
                                            For Data to be sent to tracked in grafana<br />
                                            <ul>
                                                <li className={facilityNameOfImportantHubColor}> facility_type must be either "commercial" or "consumer" (On "Facility" screen)</li>
                                                <li className={warningsToTracktHubColor}>send_warnings_to_slack must be set to "Y"</li>
                                            </ul>                                          
                                        </fieldset>
                                    </div>
                            </ErrorBoundary>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div style={{height:hubTabDataHeight}}>
                            <Tabs>
                                <TabList>
                                    <Tab disabled={this.state.hubPopupModified}>Provision</Tab>
                                    <Tab disabled={this.state.hubPopupModified}>Test</Tab>
                                    <Tab disabled={this.state.hubPopupModified}>Final Provision</Tab>
                                    <Tab disabled={this.state.hubPopupModified}>Final Test</Tab>
                                </TabList>
                                <TabPanel>
                                <ErrorBoundary>
                                    <div>
                                        <button  disabled={!this.state.hubPopupModified} className="" onClick={() => this.closeHub() }>Close</button>
                                        <button  disabled={!this.state.hubPopupModified} className="" onClick={() => this.saveHub() }>Save</button>
                                    </div>
                                    <fieldset>
                                            <legend >yolink</legend>
                                            <HubInput owner={this} dbColumn='yolink_serial_number' ></HubInput>
                                            <BarCodePopupButton key="barcodeYolinkSerialNumber"
                                                defaultValue={this.state.hub.yolink_serial_number}
                                                title="YoLink Serial Number">
                                            </BarCodePopupButton>
                                            <BarCodePopupButton key="barcodeYolinkNote"
                                                defaultValue={this.state.yolinkNote}
                                                >
                                            </BarCodePopupButton>
                                        </fieldset>
                                        <fieldset>
                                            <legend >Primary Cassia</legend>
                                            <HubInput owner={this} dbColumn='bluetooth_hub_mac' ></HubInput>
                                        </fieldset>
                                        <fieldset>
                                            <legend >Cradlepoint</legend>
                                            <HubInput owner={this} dbColumn='cell_device_serial_number' ></HubInput>
                                            <HubInput owner={this} dbColumn='cell_sim_ICCID' ></HubInput>
                                        </fieldset>
                                        <b>Move To:</b>
                                        &nbsp;
                                        <button disabled={this.state.hubPopupModified} onClick={() => this.moveCurrentFacility(FacilityPopup.inventoryFacilityId,"Inventory") }>Inventory</button>
                                        &nbsp;
                                        <button onClick={()=>{this.exportHubLabelCsv()}} >Export Labels CSV</button>
                                        &nbsp;
                                        <ExecuteScriptPopupButton
                                                    disabled={this.state.hubPopupModified}
                                                    securityObject={this.props.securityObject}
                                                    buttonLabel="Configure hub push_NCM_initial_config.sh"
                                                    screenLabel="Configure hub push_NCM_initial_config.sh"
                                                    onClose={()=>this.loadData(true)}
                                                    url={`api/call_hub_push_NCM_initial_config?hostname=${this.state.hub.hostname}&cell_wifi_facility_password=${this.state.hub.cell_wifi_facility_password}`}
                                                ></ExecuteScriptPopupButton>
                                    </ErrorBoundary>
                                </TabPanel>
                                <TabPanel>
                                    <table>
                                        <tr>
                                            <td className='plain'>
                                                Number of times:
                                                <input type="number" className="input3Digits" 
                                                    id="test_instance_count" min="1" max="100" defaultValue={1}
                                                    onChange={()=>this.setState({test_instance_count: document.getElementById("test_instance_count").value })}
                                                    ></input>
                                                <ExecuteScriptPopupButton
                                                    disabled={this.state.hubPopupModified}
                                                    securityObject={this.props.securityObject}
                                                    buttonLabel="Test Hub"
                                                    screenLabel="Test Hub"
                                                    onClose={()=>this.loadData(true)}
                                                    url={`api/automatedHubTest?hostname=${this.state.hub.hostname}&user=${this.state.hub.processor_user}&port=${this.state.hub.processor_app_port}&test_instance_count=${this.state.test_instance_count}`}
                                                ></ExecuteScriptPopupButton>

                                            </td>
                                            <td className='plain'>
                                                To test a hub make sure:
                                                <ul>
                                                    <li>hub is connected to the "power tester block", "power tester", and the tester is powered</li>
                                                    <li>the fan is on, and test wearables are draped over the fan</li>
                                                    <li>the test wearables are plugged into the "wearable tester", and tester is powered</li>
                                                    <li>the "bracelet tester" is plugged into a usb power supply</li>
                                                    <li>Press the "Test Hub" Button</li>
                                                </ul>
                                            </td>
                                            <td className='plain'>
                                                <a target="blank" href="https://sites.google.com/wavedds.com/internal/general-processes/using-device-app/automated-testing">for additional information</a>
                                            </td>
                                        </tr>
                                    </table>
                                    <div>
                                    </div>
                                    <TableScrollbar  height={hubTabDataHeight}>
                                        <ErrorBoundary>
                                            <Table columns={[
                                                        { title:'Status', key: 'status_plus', width :10 }
                                                        ,{ title:'Description', key: 'test_descriptior', width :70 }
                                                        ,{ title: 'start', key: 'test_started', width :10 }
                                                        ,{ title: 'end', key: 'test_completed', width :10 }
                                                        ]} 
                                                        dataSource={this.returnEmptyArrayInNotArray(this.state.hub.tests)} 
                                                        onRowClick={this.displayHubTest.bind(this)} 
                                                        />
                                        </ErrorBoundary>
                                    </TableScrollbar>                                    
                                </TabPanel>
                                <TabPanel>
                                    <div>
                                        <button  disabled={!this.state.hubPopupModified} className="" onClick={() => this.closeHub() }>Close</button>
                                        <button  disabled={!this.state.hubPopupModified} className="" onClick={() => this.saveHub() }>Save</button>
                                    </div>
                                    <fieldset>
                                        <legend >Cellular (Cradlepoint)</legend>
                                        <HubInput owner={this} dbColumn='cell_device_serial_number' ></HubInput>
                                        <HubInput owner={this} dbColumn='cell_wifi_facility_ssid' ></HubInput>
                                        <HubInput owner={this} dbColumn='cell_wifi_facility_password' type="password" >
                                            <button onClick={this.toggleinputcell_wifi_facility_password}>View/Hide</button>
                                            <button onClick={this.decodeinputcell_wifi_facility_password.bind(this)}>Decode</button>
                                            <ExecuteScriptPopupButton
                                                disabled={this.state.hubPopupModified}
                                                securityObject={this.props.securityObject}
                                                buttonLabel="Updating facility wifi on cellular router"
                                                screenLabel="Updating facility wifi on cellular router ..."
                                                onClose={()=>this.loadData(true)}
                                                url={`api/updateFacilityWiFiOnCellRouter?hostname=${this.state.hub.hostname}&user=${this.state.hub.processor_user}&port=${this.state.hub.processor_app_port}`}
                                            ></ExecuteScriptPopupButton>
                                            <ExecuteScriptPopupButton
                                                disabled={this.state.hubPopupModified}
                                                securityObject={this.props.securityObject}
                                                buttonLabel="Updating cellular router data"
                                                screenLabel="Updating cellular router data ..."
                                                onClose={()=>this.loadData(true)}
                                                url={`api/updateFacilityWiFiData?hostname=${this.state.hub.hostname}`}
                                            ></ExecuteScriptPopupButton>                                                
                                        </HubInput>
                                    </fieldset>                                    
                                    <fieldset>
                                        <legend >Customer</legend>
                                        <HubInput owner={this} dbColumn='name'></HubInput>
                                    </fieldset>
                                    <fieldset>
                                        <legend >Primary Cassia</legend>
                                        <HubInput owner={this} dbColumn='bluetooth_hub_mac' ></HubInput>
                                    </fieldset>
                                    &nbsp;
                                    <ExecuteScriptPopupButton
                                                    disabled={this.state.hubPopupModified}
                                                    securityObject={this.props.securityObject}
                                                    buttonLabel="Configure hub push_NCM_final_config.sh"
                                                    screenLabel="Configure hub push_NCM_final_config.sh"
                                                    onClose={()=>this.loadData(true)}
                                                    url={`api/call_hub_push_NCM_final_config?hostname=${this.state.hub.hostname}&cell_wifi_facility_password=${this.state.hub.cell_wifi_facility_password}`}
                                                ></ExecuteScriptPopupButton>
                                </TabPanel>
                                <TabPanel>
                                    <TableScrollbar  height={hubTabDataHeight}>
                                        <ErrorBoundary>
                                            <Table columns={[
                                                        { title:'Status', key: 'status_plus', width :10 }
                                                        ,{ title:'Description', key: 'test_descriptior', width :70 }
                                                        ,{ title: 'start', key: 'test_started', width :10 }
                                                        ,{ title: 'end', key: 'test_completed', width :10 }
                                                        ]} 
                                                        dataSource={this.returnEmptyArrayInNotArray(this.state.hub.tests)} 
                                                        onRowClick={this.displayHubTest.bind(this)} 
                                                        />
                                        </ErrorBoundary>
                                    </TableScrollbar>
                                </TabPanel>
                            </Tabs>
                       </div>
                    </TabPanel>
                    <TabPanel>
                        <button onClick={() => this.addHubNote(this)}>+</button>
                        <Dropdown
                            name="note_type" 
                            options={noteTypeList} 
                            onChange={this.updateNoteTypeInputValue.bind(this)} 
                            placeholder="Filter by Type" 
                        />   
                        <TableScrollbar  height={hubTabDataHeight}>
                            <ErrorBoundary>
                                <Table columns={[
                                            //{ title: 'Date', key: 'notedate', width :15, render:NotePopup.renderDateNoteDate }
                                            //,{ title:'Type', key: 'note_type', width :15 }
                                            { title:'Note', key: 'note', width :70, render:tableColumnRender.renderNoteWithPossibleLink }
                                            ]} 
                                            dataSource={this.returnEmptyArrayInNotArray(this.state.notesDisplay)} 
                                            onRowClick={this.editHubNote.bind(this)} 
                                            />
                            </ErrorBoundary>
                        </TableScrollbar>
                    </TabPanel>
                    <TabPanel>
                        <TableScrollbar height={hubTabDataHeight}>
                            <ErrorBoundary>
                                <Table columns={[
                                                {title: 'id(on hub)', key: 'id', width :15 }
                                                ,{title: 'Name', key: 'name', width :15 }
                                                ,{title: 'Type', key: 'type', width :15 }
                                                ,{title: 'IP', key: 'ip', width :15 }
                                                ,{title: 'MAC', key: 'mac', width :15 }
                                                ,{title: 'Connected', key: 'connected', width :15 }
                                                ,{title: 'Critical', key: 'critical', width :15 }
                                                ,{title: 'Notes', key: 'notes', width :50 }
                                            ]} dataSource={this.state.hubPopupDataNote.json.accessories} 
                                            onRowClick={this.openHistory.bind(this)}
                                            />
                            </ErrorBoundary>
                        </TableScrollbar>
                    </TabPanel>   
                    <TabPanel>
                        <button  onClick={() => this.exportWearablesScript().bind(this) }>Export All Wearables Script</button>
                        <button  onClick={() => this.exportWearablesScript(this.headsetType).bind(this) }>Export Trackers Script</button>
                        <button  onClick={() => this.deleteWearablesScript().bind(this) }>Delete All Wearables Script</button>
                        <button  onClick={() => this.deleteWearablesScript(this.headsetType).bind(this) }>Delete Trackers Script</button>
                        <TableScrollbar height={hubTabDataHeight}>
                            <ErrorBoundary>
                                <Table columns={[
                                                {title: 'id(on hub)', key: 'id', width :15 }    
                                                ,{title: 'Name', key: 'name', width :15 }
                                                ,{title: 'deleted', key: 'is_deleted', width :15 }
                                                ,{title: 'Type', key: 'type', width :15 }
                                                ,{title: 'Barcode', key: 'barcode', width :15 }
                                                ,{title: 'Plastic Barcode', key: 'plastic_barcode', width :15 }
                                                ,{title: 'Low Battery', key: 'low_battery', width :15, render:this.renderLowBattery.bind(this) }
                                                ,{title: 'Left Beacon', key: 'left_beacon', width :15, render:this.renderBeacon.bind(this) }
                                                ,{title: 'Right Beacon', key: 'right_beacon', width :15, render:this.renderBeacon.bind(this) }
                                            ]} dataSource={this.returnSortedWearable(this.state.hubPopupDataNote.json.headsets)} 
                                            onRowClick={this.openHistory.bind(this)}
                                            />
                            </ErrorBoundary>
                        </TableScrollbar>
                    </TabPanel>   
                    <TabPanel>
                        <button  onClick={() => this.exportWearablesScript().bind(this) }>Export All Wearables Script</button>
                        <button  onClick={() => this.exportWearablesScript(this.toddleType).bind(this) }>Export Buddy Script</button>
                        <button  onClick={() => this.deleteWearablesScript().bind(this) }>Delete All Wearables Script</button>
                        <button  onClick={() => this.deleteWearablesScript(this.toddleType).bind(this) }>Delete Buddy Script</button>
                        <TableScrollbar height={hubTabDataHeight}>
                            <ErrorBoundary>
                                <Table columns={[
                                            {title: 'id(on hub)', key: 'id', width :15 }    
                                            ,{title: 'Name', key: 'name', width :15 }
                                            ,{title: 'deleted', key: 'is_deleted', width :15 }
                                            ,{title: 'Barcode', key: 'barcode', width :15 }
                                            ,{title: 'Plastic Barcode', key: 'plastic_barcode', width :15 }
                                            ,{title: 'Low Battery', key: 'low_battery', width :15, render:this.renderLowBattery.bind(this) }
                                            ,{title: 'Left Beacon', key: 'left_beacon', width :15, render:this.renderBeacon.bind(this) }
                                            ,{title: 'Right Beacon', key: 'right_beacon', width :15, render:this.renderBeacon.bind(this) }
                                        ]} dataSource={this.returnSortedWearable(this.getBuddieTagList())} 
                                        onRowClick={this.openHistory.bind(this)}
                                        />
                            </ErrorBoundary>
                        </TableScrollbar>
                    </TabPanel> 
                    <TabPanel>
                        <button  onClick={() => this.exportWearablesScript().bind(this) }>Export All Wearables Script</button>
                        <button  onClick={() => this.exportWearablesScript(this.braceletType).bind(this) }>Export Bracelet Script</button>
                        <button  onClick={() => this.deleteWearablesScript().bind(this) }>Delete All Wearables Script</button>
                        <button  onClick={() => this.deleteWearablesScript(this.braceletType).bind(this) }>Delete Bracelet Script</button>
                        <TableScrollbar height={hubTabDataHeight}>
                            <ErrorBoundary>
                                <Table columns={[
                                            {title: 'id(on hub)', key: 'id', width :15 }    
                                            ,{title: 'Name', key: 'name', width :15 }
                                            ,{title: 'deleted', key: 'is_deleted', width :15 }
                                            ,{title: 'Barcode', key: 'barcode', width :15 }
                                            ,{title: 'Plastic Barcode', key: 'plastic_barcode', width :15 }
                                            ,{title: 'Low Battery', key: 'low_battery', width :15, render:this.renderLowBattery.bind(this) }
                                            ,{title: 'Beacon', key: 'beacon', width :15, render:this.renderBeacon.bind(this) }
                                        ]} dataSource={this.returnSortedWearable(this.state.hubPopupDataNote.json.bracelets)} 
                                        onRowClick={this.openHistory.bind(this)} />
                            </ErrorBoundary>
                        </TableScrollbar>
                    </TabPanel>                                                          
                    <TabPanel>
                        <TableScrollbar height={hubTabDataHeight}>
                            <ErrorBoundary>
                                <Table columns={[
                                            {title: 'id(on hub)', key: 'id', width :15 }    
                                            ,{title: 'Name', key: 'name', width :15 }
                                            ,{title: 'deleted', key: 'is_deleted', width :15 }
                                            ,{title: 'Barcode', key: 'barcode', width :15 }
                                            ,{title: 'Plastic Barcode', key: 'plastic_barcode', width :15 }
                                            ,{title: 'Low Battery', key: 'low_battery', width :15, render:this.renderLowBattery.bind(this) }
                                            ,{title: 'Left Beacon', key: 'left_beacon', width :15, render:this.renderBeacon.bind(this) }
                                            ,{title: 'Right Beacon', key: 'right_beacon', width :15, render:this.renderBeacon.bind(this) }
                                        ]} dataSource={this.returnSortedWearable(this.state.hubPopupDataNote.json.lifeguardTags)} 
                                        onRowClick={this.openHistory.bind(this)} />
                            </ErrorBoundary>
                        </TableScrollbar>
                    </TabPanel>                                                          
                    <TabPanel>
                        <div style={{height:hubTabDataHeight}}>
                            <ErrorBoundary>
                                <div id="hub-data" style={{height:hubTabDataHeight, width:"850px" }} className="float-left-scroll" >
                                                                                                                                                                
                                    <label>node_version</label>
                                    <input type="text" disabled name="node_version" id="node_version" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.node_version}  />
                                    <br />
                                                                                                                                        
                                    <label>node_env</label>
                                    <input type="text" disabled name="node_env" id="node_env" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.node_env}  />
                                    <br />

                                    {this.state.hubPopupDataNote.json.sysinfo.environment ?    
                                        <div> 
                                            <label>ENVIRONMENT</label> 
                                            <br />

                                            <label>.PATH</label>
                                            <input type="text" disabled name="environment.PATH" id="environment.PATH" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.PATH}  />
                                            <br />
                                                                                                                                
                                            <label>.HOSTNAME</label>
                                            <input type="text" disabled name="environment.HOSTNAME" id="environment.HOSTNAME" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.HOSTNAME}  />
                                            <br />
                                                                                                                
                                            <label>.HUB_MODEL</label>
                                            <input type="text" disabled name="environment.HUB_MODEL" id="environment.HUB_MODEL" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.HUB_MODEL}  />
                                            <br />
                                                                                                            
                                            <label>.BUILD_TYPE</label>
                                            <input type="text" disabled name="environment.BUILD_TYPE" id="environment.BUILD_TYPE" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.BUILD_TYPE}  />
                                            <br />
                                                                                                        
                                            <label>.VERSION</label>
                                            <input type="text" disabled name="environment.environment.VERSION" id="environment.environment.VERSION" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.ENVIRONMENT_VERSION}  />
                                            <br />
                                                                    
                                            <label>.SUPERVISOR_VERSION</label>
                                            <input type="text" disabled name="environment.SUPERVISOR_VERSION" id="environment.SUPERVISOR_VERSION" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.SUPERVISOR_VERSION}  />
                                            <br />
                                                                        
                                            <label>.SHUTDOWN_LISTENER_VERSION</label>
                                            <input type="text" disabled name="environment.SHUTDOWN_LISTENER_VERSION" id="environment.SHUTDOWN_LISTENER_VERSION" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.SHUTDOWN_LISTENER_VERSION}  />
                                            <br />
                                            
                                            <label>.WIFI_CONNECT_VERSION</label>
                                            <input type="text" disabled name="environment.WIFI_CONNECT_VERSION" id="environment.WIFI_CONNECT_VERSION" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.WIFI_CONNECT_VERSION}  />
                                            <br />
                                                                
                                            <label>.WAVE_V2_VERSION</label>
                                            <input type="text" disabled name="environment.WAVE_V2_VERSION" id="environment.WAVE_V2_VERSION" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.WAVE_V2_VERSION}  />
                                            <br />
                                                                                    
                                            <label>.PORT</label>
                                            <input type="text" disabled name="environment.PORT" id="environment.PORT" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.PORT}  />
                                            <br />
                                                                                                                                
                                            <label>.PORTAL_GATEWAY</label>
                                            <input type="text" disabled name="environment.PORTAL_GATEWAY" id="environment.PORTAL_GATEWAY" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.PORTAL_GATEWAY}  />
                                            <br />
                                                                                        
                                            <label>.SERIAL</label>
                                            <input type="text" disabled name="environment.SERIAL" id="environment.SERIAL" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.SERIAL}  />
                                            <br />
                                                                                                                        
                                            <label>.WAVE_ECHOIP_SERVICE</label>
                                            <input type="text" disabled name="environment.WAVE_ECHOIP_SERVICE" id="environment.WAVE_ECHOIP_SERVICE" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.WAVE_ECHOIP_SERVICE}  />
                                            <br />
                                                                    
                                            <label>.DEBUG</label>
                                            <input type="text" disabled name="environment.DEBUG" id="environment.DEBUG" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.DEBUG}  />
                                            <br />
                                                                                                                            
                                            <label>.NODE_ENV</label>
                                            <input type="text" disabled name="environment.NODE_ENV" id="environment.NODE_ENV" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.NODE_ENV}  />
                                            <br />
                                                                                                                
                                            <label>.MODEL</label>
                                            <input type="text" disabled name="environment.MODEL" id="environment.MODEL" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.MODEL}  />
                                            <br />
                                                                                                                            
                                            <label>.WAVE_DATA</label>
                                            <input type="text" disabled name="environment.WAVE_DATA" id="environment.WAVE_DATA" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.WAVE_DATA}  />
                                            <br />
                                                                                                            
                                            <label>.GIT_VERSION</label>
                                            <input type="text" disabled name="environment.GIT_VERSION" id="environment.GIT_VERSION" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.GIT_VERSION}  />
                                            <br />
                                                                                                    
                                            <label>.HOME</label>
                                            <input type="text" disabled name="environment.HOME" id="environment.HOME" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.HOME}  />
                                            <br />
                                                                                                                                
                                            <label>.WORKER_TYPE</label>
                                            <input type="text" disabled name="environment.WORKER_TYPE" id="environment.WORKER_TYPE" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.environment.WORKER_TYPE}  />
                                            <br />
                                        </div>
                                        :<></>
                                    }                                                          
                                    <label>hub_ready</label>
                                    <input type="text" disabled name="hub_ready" id="hub_ready" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.hub_ready}  />
                                    <br />
                                                                                                                                                
                                    <label>voltage</label>
                                    <input type="text" disabled name="voltage" id="voltage" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.voltage}  />
                                    <br />
                                                                                                                                                            
                                    <label>current</label>
                                    <input type="text" disabled name="current" id="current" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.current}  />
                                    <br />
                                                                                                                                                            
                                    <label>battery</label>
                                    <input type="text" disabled name="battery" id="battery" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.battery}  />
                                    <br />
                                                                                                                                                            
                                    <label>version</label>
                                    <input type="text" disabled name="version" id="version" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.version}  />
                                    <br />
                                                                                                                                                            
                                    <label>external_ip</label>
                                    <input type="text" disabled name="external_ip" id="external_ip" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.external_ip}  />
                                    <br />
                                                                                                                                            
                                    <label>process_hapi_cpu</label>
                                    <input type="text" disabled name="process_hapi_cpu" id="process_hapi_cpu" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.process_hapi_cpu}  />
                                    <br />
                                                                                                                        
                                    <label>process_hapi_mem</label>
                                    <input type="text" disabled name="process_hapi_mem" id="process_hapi_mem" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.process_hapi_mem}  />
                                    <br />
                                                                                                                        
                                    <label>process_advertisements_cpu</label>
                                    <input type="text" disabled name="process_advertisements_cpu" id="process_advertisements_cpu" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.process_advertisements_cpu}  />
                                    <br />
                                                                                
                                    <label>process_advertisements_mem</label>
                                    <input type="text" disabled name="process_advertisements_mem" id="process_advertisements_mem" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.process_advertisements_mem}  />
                                    <br />
                                                                                
                                    <label>process_alarms_cpu</label>
                                    <input type="text" disabled name="process_alarms_cpu" id="process_alarms_cpu" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.process_alarms_cpu}  />
                                    <br />
                                                                                                                
                                    <label>process_alarms_mem</label>
                                    <input type="text" disabled name="process_alarms_mem" id="process_alarms_mem" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.process_alarms_mem}  />
                                    <br />
                                                                                                                
                                    <label>process_watchdog_cpu</label>
                                    <input type="text" disabled name="process_watchdog_cpu" id="process_watchdog_cpu" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.process_watchdog_cpu}  />
                                    <br />
                                                                                                        
                                    <label>process_watchdog_mem</label>
                                    <input type="text" disabled name="process_watchdog_mem" id="process_watchdog_mem" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.process_watchdog_mem}  />
                                    <br />
                                                                                                        
                                    <label>app_uptime</label>
                                    <input type="text" disabled name="app_uptime" id="app_uptime" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.app_uptime}  />
                                    <br />
                                                                  
                                    {this.state.hubPopupDataNote.json.sysinfo.environment ?    
                                        <div>                                                                                                                                                
                                            <label>active_wearable_counts_bracelet</label>
                                            <input type="text" disabled name="active_wearable_counts_bracelet" id="active_wearable_counts_bracelet" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.active_wearable_counts.bracelet}  />
                                            <br />
                                                                    
                                            <label>active_wearable_counts_headset</label>
                                            <input type="text" disabled name="active_wearable_counts_headset" id="active_wearable_counts_headset" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.active_wearable_counts.headset}  />
                                            <br />
                                                                        
                                            <label>active_wearable_counts_buddy</label>
                                            <input type="text" disabled name="active_wearable_counts_buddy" id="active_wearable_counts_buddy" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.active_wearable_counts.buddy}  />
                                            <br />
                                                                        
                                        </div>
                                        :<></>
                                    }                                                          

                                    <label>missing_beacons</label>
                                    <input type="text" disabled name="missing_beacons" id="missing_beacons" defaultValue={ JSON.stringify(this.state.hubPopupDataNote.json.sysinfo.missing_beacons)}  />
                                    <br />
                                                                                            
                                    <label>accessory_warning_count</label>
                                    <input type="text" disabled name="accessory_warning_count" id="accessory_warning_count" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.accessory_warning_count}  />
                                    <br />
                                                                                            
                                    <label>last_updated_time</label>
                                    <input type="text" disabled name="last_updated_time" id="last_updated_time" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.last_updated_time}  />
                                    <br />

                                    <label>DEPRICATED</label>
                                    <br />

                                    <label>node_env</label>
                                    <input type="text" disabled name="node_env" id="node_env" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.node_env}  />
                                    <br />

                          <label>git_hash</label>
                                <input type="text" disabled name="git_hash" id="git_hash" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.git_hash}  />
                                <br />
                                
                                <label>git_date</label>
                                <input type="text" disabled name="git_date" id="git_date" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.git_date}  />
                                <br />
                                
                                <label>git_branch</label>
                                <input type="text" disabled name="git_branch" id="git_branch" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.git_branch}  />
                                <br />
                                
                                <label>version</label>
                                <input type="text" disabled name="version" id="version" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.version}  />
                                <br />

                                <label>external_ip</label>
                                <input type="text" disabled name="external_ip" id="external_ip" defaultValue={ this.state.hubPopupDataNote.json.sysinfo.external_ip}  />
                                <br />
                                </div>
                            </ErrorBoundary>                            
                        </div>
                    </TabPanel>                                            
                    <TabPanel>
                        <TableScrollbar height={hubTabDataHeight}>
                            <ErrorBoundary>
                                <Table columns={[
                                            {title: 'key', key: 'key', width :15 }
                                            ,{title: 'Label', key: 'label', width :15 }
                                            ,{title: 'Description', key: 'description', width :35 }
                                            ,{title: 'Value', key: 'value', width : 25}
                                        ]} dataSource={this.state.hubPopupDataSettings} 
                                        onRowClick={this.openHubSettingGenerator.bind(this)} />
                            </ErrorBoundary>
                        </TableScrollbar>
                    </TabPanel>                                                          
                </Tabs>
                <NotePopup
                    tableName="hub_note"
                    filterLoc="h"
                    note={this.state.hubNote}
                    facility={this.props.facility}
                    hub={this.state.hub}
                    visible={this.state.hubNoteVisible}
                    securityObject={this.props.securityObject}
                    onCloseNotePopup={this.closeNotePopup.bind(this)}
                ></NotePopup> 
                <BeaconHistoryPopup
                    securityObject={this.props.securityObject}
                    beaconPair={this.state.beaconPair}
                    closeBeaconHistoryPopup={this.closeBeaconHistoryPopup.bind(this)}
                    >
                </BeaconHistoryPopup>
                <HubTestPopup
                    securityObject={this.props.securityObject}
                    hubTest={this.state.hubTest}
                    closeHubTestPopup={this.closeHubTestPopup.bind(this)}    >                
                </HubTestPopup>
                <HubSettingsPopup
                    hubSetting={this.state.hubSetting}
                    hubSettingVisible={this.state.hubSettingVisible}
                    closeHubSettingsPopup={this.closeHubSettingsPopup.bind(this)}
                    hub={this.state.hub}
                >   
                </HubSettingsPopup>
                <Popup trigger={this.state.factoryDevicesPopupVisible}>
                    <div className="align-right">
                        <button className="" onClick={() => this.closeFactoryDevicesPopup() }>x</button>
                    </div>
                    <FactoryDevices 
                        securityObject={this.props.securityObject}
                        height="50vh"
                        onRowClick={(rowData) => this.closeFactoryDevicesPopup(rowData) }
                    ></FactoryDevices>
                </Popup>
                <FacilityPopup 
                    facilityId={this.state.facilityPopupId}
                    visible={this.state.facilityPopupId}
                    securityObject={this.props.securityObject}
                    onCloseFacilityPopup={this.closeFacilityPopup.bind(this)}
                >
                </FacilityPopup>   
        </Popup>

        ) :"";
    }

    closeHubPopup(){
        if(this.state.hubPopupModified){
            if (window.confirm("The screen has been modifies.  Would you like to exit without saving changes?") === true) {
                this.props.closeHub();
                } 
        } else {
            this.props.closeHub();
        }
    }

    updateHubInputValue(evt){
        let hubPopupPost=this.state.hubPopupPost;
        hubPopupPost[evt.currentTarget.name] = evt.currentTarget.value;         
        thisApp.setState({
            hubId:true,
            hubPopupPost:hubPopupPost
        });        
    }
    saveHub(){
        let hubPopupPost=this.state.hubPopupPost;
        hubPopupPost.id=this.state.hub.id;
        this.setState({
            hubPopupPost:hubPopupPost
        })
        db.saveData( this.props.securityObject
                        , this.state.hubPopupPost
                        ,"api/updateHub"
                        , this.setHubSaved());
    }
    setHubSaved(){
            this.setState({
                hubPopupModified:false,
                hubPopupPost:{}
            });
            //this.loadData();
            functions.sleep(3000).then(() => { this.loadData(); });
    }
    closeHub(){
        this.setState({
            hubPopupModified:false,
            hubPopupPost:{},
            hub:emptyHub,
            hubId:this.newHubId
        });
        this.props.onCloseHubPopup();        
    }
    closeHubSettingsPopup(){
        this.setState({
            hubSettingVisible:false
        });     
    }    
    moveCurrentFacility(toId,desc){
        if(window.confirm("Are you sure you want to move this hub to "+desc+toId+"?")===true){
            let hubPopupPost=this.state.hubPopupPost;
            hubPopupPost.facility_id = toId;
            hubPopupPost.id=this.state.hub.id;
            this.setState({
                hubPopupPost:hubPopupPost
            })
            //let ids=[ this.state.hub.facility_id, toId ];
            let thisApp=this;
            db.saveData( this.props.securityObject
                , this.state.hubPopupPost
                ,"api/moveHub"
                , function(){
                    thisApp.props.onCloseHubPopup();
                    //this.setMoveHubPopupVisible(false);
                    //thisApp.setHubPopupVisible(false);
                    thisApp.setState({
                        hubPopupModified:false
                    });
                    //thisApp.props.onUpdateTable(ids);
                    this.closeHub();
                });        
            }
    }
    getHmpUrl(host){
        return "http://" + host +":" + this.state.hub.processor_app_port;
    }
    copyPiPasswordToClipBoard(){
        let clipBoard=this.state.hub.processor_password;
        if(clipBoard===null || clipBoard.length===0){
            clipBoard="raspberry";
            if(this.state.hub.hostname.indexOf("w10")===0){
                clipBoard="pi";
            }
        }
        functions.copyToClipBoard(clipBoard);
    }
    getSSHUrl(host,processor_user){
        this.copyPiPasswordToClipBoard();
        return `ssh://${processor_user}@${host}` ;
    }
    //-v  ssh -o StrictHostKeyChecking=no
    getDefaultProxyPort(){
        //const cookies = new Cookies();
        let proxyPort=this.cookies.get('ProxyPort');
        if(!proxyPort){
            proxyPort="33003";
        }
        return proxyPort;
    }
    getProxyPort(){
        return document.getElementById('proxyPort').value;
    }
    proxyNew(){
        // iframe method 
        this.setState({
            "remoteAccessUrl":this.props.securityObject.httpServer+"RemoteHubAccess"
                +`?port=${this.getProxyPort()}&`
                +`hostname=${this.state.hub.hostname}&`
                +`userid=${this.state.hub.processor_user}&`
                +`sessionId=${this.props.securityObject.userSessionId}`
    });
            
/*
        let options = {};
        options.url = url;
        options.headers = headers;
        options.mode = '_blank';
        window.open(options);                
*/
/*
        //    blob method 
        //----------------------
        //set up url
        var headers = {
            'Session-Id':this.props.securityObject.userSessionId
        };
             
        let url=this.props.securityObject.httpServer+"RemoteHubAccess"

        fetch(url, {
            method: "GET",
            headers
            })
            .then((res) => res.blob())
            .then((blob) => {
                console.log(blob);
                var _url = window.URL.createObjectURL(blob);
                //_url+=`?port=${this.getProxyPort()}&`
                //    +`hostname=${this.state.hub.hostname}&`
                //    +`userid=${this.state.hub.processor_user}&`;

                console.log(_url);
                window.open(_url, "_blank",'height=780,width=450,location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes').focus();
            })
                    
*/        
/*
        //    url method 
        //----------------------
        let url=this.props.securityObject.httpServer+"RemoteHubAccess"
                +`?port=${this.getProxyPort()}&`
                +`hostname=${this.state.hub.hostname}&`
                +`userid=${this.state.hub.processor_user}&`
                //+`sessionId=${this.props.securityObject.userSessionId}`;
        window.open(url,'Hub Remote Access','height=780,width=450,location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes');        
*/        
    }
    proxyCmd(){
        let port=this.getProxyPort();
        let str=""
        str+=`1-Paste this command into a command prompt window to start tunnel\n`;
        str+=`   ssh -L ${port}:localhost:${port} ubuntu@3.128.137.10 "ssh -f -N -D ${port} ${this.state.hub.processor_user}@${this.state.hub.hostname}.hubs.wavedds.com"\n`;
        str+=`2-Paste one of the following commands into your proxy browser"\n`;
        str+=`   http://${this.state.hub.hostname}.hub.wavedds.net:${this.state.hub.processor_app_port}/ \n`;
        str+=`   http://192.168.13.100:${this.state.hub.processor_app_port}/ \n`;
        //str+=`echo ""\n`;
        //str+=`ssh ubuntu@3.128.137.10 "sudo fuser -k ${port}/tcp"\n`
        //str+`3-Press enter key when finished to kill tunnel"\n`;
        str+='3-Paste this command into a command prompt window to stop tunnel\n'
        str+=`ssh ubuntu@3.128.137.10 "sudo fuser -k ${port}/tcp"\n`
        str+='4-Paste this command into a command prompt window to see if tunnel is still opened\n'
        str+=`ssh ubuntu@3.128.137.10 "sudo netstat -tulpn | grep LISTEN"\n`;
        str+=`\n`
        str=`ssh -L ${port}:localhost:${port} ubuntu@3.128.137.10 "ssh -f -N -D ${port} ${this.state.hub.processor_user}@${this.state.hub.hostname}.hubs.wavedds.com"`;
        //functions.copyToClipBoard(str);
        prompt("1-Paste this command into a command prompt window to start tunnel (keep app running)",
            str
        );
        str=`http://${this.state.hub.hostname}.hub.wavedds.net:${this.state.hub.processor_app_port}/`;
        //functions.copyToClipBoard(str);
        prompt("2-Paste this commands into your proxy browser (firefox) to open HMP app",
            str
        );
        str=`ssh ubuntu@3.128.137.10 "sudo fuser -k ${port}/tcp"`;
        //functions.copyToClipBoard(str);
        prompt("3-Press ctrl-c in command prompt window to stop app \nthen Paste this command into a command prompt window to stop tunnel",
            str
        );
        str=`ssh ubuntu@3.128.137.10 "sudo netstat -tulpn | grep LISTEN"`;
        //functions.copyToClipBoard(str);
        prompt("4-Paste this command into a command prompt window to make sure tunnel is closed (optional)",
            str
        );        
        //str+="pause\n"
        //functions.copyToClipBoard(str);
    }
    startProxy(){
        let port=this.getProxyPort();
        //sudo fuser -k 33003/tcp
       let str=`ssh://-L%20${port}%3Alocalhost%3A${port}%20ubuntu%403.128.137.10%20"ssh%20-f%20-N%20-D%20${port}%20${this.state.hub.processor_user}%40${this.state.hub.hostname}.hubs.wavedds.com"`;
        //alert(str);
        return str;
    }
    stopProxy(){
        let port=this.getProxyPort();
        //sudo fuser -k 33003/tcp
        return `ssh://ubuntu@3.128.137.10%20%22sudo%20fuser%20-k%20${port}/tcp%22x`;
    }
    downloadHubData(obj){
        const fileName = "WaveHubData-"+this.state.hubPopupData.hostname+"-";
        let json = JSON.stringify(obj,null,2);
        functions.downloadJsonFile( fileName, json, obj.note_date);
    }
    returnEmptyArrayInNotArray(inArray,x){
        try {
            if(inArray===undefined){
                return []
            }
            else{
                return inArray;
            }
        } catch(e){
            return [];
        }
    }
    returnSortedWearable(inArr){

        let res=this.returnEmptyArrayInNotArray(inArr);
        if(Array.isArray(res)){
            return res.sort(compare);
        } else {
            return [];
        }

        function compare(a, b) {
            // Use toUpperCase() to ignore character casing
            const nameA = normalize(a.name);
            const nameB = normalize(b.name);
          
            let comparison = 0;
            if (nameA > nameB) {
              comparison = 1;
            } else if (nameA < nameB) {
              comparison = -1;
            }
            return comparison;

            function normalize(name){
                if(name===undefined || name===null){
                    return "          ";
                } else {
                    return name.padStart(10," ");
                }
            }
          }
    }
    renderBeacon(cellData, rowData, rowIndex){
        let batteryClass="good-battery";
//        if( cellData.battery < this.state.hubErrors.badBatteryThreshold){
//            batteryClass="bad-battery";
//        }
        let msg = `${cellData.id} ${cellData.major} / ${cellData.minor} battery:${cellData.battery}`;
        return React.createElement('p',{className:batteryClass},msg );    
    }
    renderLowBattery(cellData, rowData, rowIndex){
        let batteryClass="good-battery";
        let msg = `Ok Battery`;
        if(rowData.low_battery){
            batteryClass="bad-battery";
            msg = `Low Battery`
        }
        
        return React.createElement('p',{className:batteryClass},msg );    
    }
    renderUpdateCheckbox(cellData, rowData, rowIndex){
        let value="x";
        if(rowData.hub_id===null){
            value="_";
        }
        return React.createElement( 'button',{
            onClick:clickUpdateButton.bind(this),
            name:rowData.id
            },value );    
    }
    closeNotePopup(){
        this.setState({
            hubNoteVisible:false           
        })
        this.loadData();
    }
    editHubNote( rowData, rowIndex ){
        this.setState({
            hubNote:rowData
            , hubNoteVisible:true
        })
        this.loadData();
    }
    openHubSettingGenerator( rowData, rowIndex ){
        this.setState({
            hubSetting:rowData
            , hubSettingVisible:true
        })
    }
    addHubNote(thisApp){
        let note = Object.assign({}, NotePopup.emptyNote);
        note.hub_id=thisApp.state.hub.id;
        thisApp.setState({
            hubNote:note
            , hubNoteVisible:true
        })
    }
    closeBeaconHistoryPopup(){
        this.setState({
            beaconPair:undefined
        });
    }
    closeHubTestPopup(reload=true){
        this.setState({
            hubTest:undefined
        });
        if(reload){
            this.loadData();
        }
    }    
    openHistory( rowData, rowIndex ){
        let beaconPair={
            left_mac_address: rowData.left_beacon.id
            ,right_mac_address: rowData.right_beacon.id
        }
        this.setState({
            beaconPair:beaconPair
        });
    }
    displayHubTest( rowData, rowIndex ){
        this.setState({
            hubTest:rowData
        })
    }
    openHubTest( rowData, rowIndex ){
        this.setState({
            hubTest:rowData
        });
    }    
    updateCommandOption(event){
        this.setState({
            commandOption:event.target.value
        });
    }
    
    // filter notes
    updateNoteTypeInputValue(option) {
        let notesDisplay=[];
        this.state.hub.notes.forEach(note=>{
            if(!option){
                notesDisplay.push(note);
            } else if(note.note_type===option.value){
                notesDisplay.push(note);
            }
        })
        this.setState({
            notesDisplay : notesDisplay
        })

    }
    exportHubLabelCsv(params){
        let url=this.props.securityObject.httpServer
                +"api/get/hubForLabels?sessionId="
                +this.props.securityObject.userSessionId;
        url+=`&id=${this.state.hub.id}`;
        window.open(url);
    }
    // set the cookie to change the Bad Battery Threshold
    updateProxyPort(e){
        this.setState({
            proxyPort:e.target.value
        })
        //const cookies = new Cookies();
        let nextYear = new Date();
        const current = new Date();
        nextYear.setFullYear(current.getFullYear() + 1);

        this.cookies.set( 'ProxyPort', e.target.value,
                                {
                                    path: '/',
                                    expires: nextYear,
                                }
        );        
    } 
    exportWearablesScript(wearableTypeInt){
        let wearables=this.getWearables(wearableTypeInt);
        let script='echo adding ${wearable.name};curl -X POST "${url}${wearableType}" -H '
            +' "accept: application/json" -H  "Content-Type: application/json" '
            +'-d "{  &quot;active&quot;: true,  &quot;name&quot;: &quot;${wearable.left_beacon.minor}&quot;, '
            +' &quot;left&quot;: { &quot;bdaddr&quot;: { &quot;bdaddr&quot;: &quot;${wearable.left_beacon.bdaddr.bdaddr}&quot;, &quot;type&quot;: &quot;random&quot; }, &quot;major&quot;: ${wearable.left_beacon.major}, &quot;minor&quot;: ${wearable.left_beacon.minor}, &quot;uuid&quot;: &quot;${wearable.left_beacon.uuid}&quot;  },'
            +' &quot;right&quot;: {&quot;bdaddr&quot;: { &quot;bdaddr&quot;: &quot;${wearable.right_beacon.bdaddr.bdaddr}&quot;,&quot;type&quot;: &quot;random&quot; }, &quot;major&quot;: ${wearable.right_beacon.major}, &quot;minor&quot;: ${wearable.right_beacon.minor},&quot;uuid&quot;: &quot;${wearable.right_beacon.uuid}&quot;  }, '
            +' &quot;test&quot;: false}"';
        let braceletScript='echo adding ${wearable.name};curl -X POST "${url}${wearableType}" -H  "accept: application/json" -H  "Content-Type: application/json" '
            +'-d "{  &quot;active&quot;: true,  &quot;name&quot;: &quot;${wearable.name}&quot;,  &quot;beacon&quot;: {    &quot;bdaddr&quot;: {'
            +'&quot;bdaddr&quot;: &quot;${wearable.beacon.id}&quot;,      &quot;type&quot;: &quot;random&quot;    },   '
            +' &quot;major&quot;: ${wearable.beacon.major},    &quot;minor&quot;: ${wearable.beacon.minor},    &quot;uuid&quot;: &quot;${wearable.beacon.uuid}&quot;  },  &quot;test&quot;: false}"'

        this.makeWearableScript(wearables
            ,[ script, script, braceletScript ]
            ,'ExportWearableScript'
            ,wearableTypeInt);
            //this.makeWearableScript(wearables, (wearable)=>{
                //return `curl -X POST "${wearable.url}${wearable.type}" -H  "accept: application/json" -H  "Content-Type: application/json" -d "{  \\"active\\": true,  \\"name\\": \\"${wearable.right_minor}\\",  \\"left\\": {    \\"bdaddr\\": {      \\"bdaddr\\": \\"${wearable.left_beacon.bdaddr.bdaddr}\\",      \\"type\\": \\"random\\"    },    \\"major\\": ${wearable.left_beacon.major},    \\"minor\\": ${wearable.left_beacon.minor},  \\"uuid\\": \\"${wearable.left_beacon.uuid}\\"  },  \\"right\\": {    \\"bdaddr\\": {      \\"bdaddr\\": \\"${wearable.right_beacon.bdaddr.bdaddr}\\",      \\"type\\": \\"random\\"    },    \\"major\\": ${wearable.right_beacon.major},    \\"minor\\": ${wearable.right_beacon.minor},    \\"uuid\\": \\"${wearable.right_beacon.uuid}\\"  },  \\"test\\": false}"`
            //});
        
    }
    deleteWearablesScript(wearableTypeInt){   
        let wearables=this.getWearables(wearableTypeInt);
        let script='echo deleting ${wearable.name};curl -X DELETE "${url}${wearableType}/${wearable.id}" -H  "accept: application/json"';
        this.makeWearableScript(wearables
            ,[ script, script, script]
            ,'DeleteWearableScript'
            ,wearableTypeInt);
    }
    getWearables(wearableType){   
        let wearables=[]
        if(wearableType===undefined || wearableType===this.headsetType){
            wearables.push(this.state.hubPopupDataNote.json.headsets);
        } else { wearables.push([]);} 
        if(wearableType===undefined || wearableType===this.toddleType){
            wearables.push(this.getBuddieTagList());
        } else { wearables.push([]);} 
        if(wearableType===undefined || wearableType===this.braceletType){
            wearables.push(this.state.hubPopupDataNote.json.bracelets);
        } else { wearables.push([]);} 
        console.log(JSON.stringify(wearables,null,2));
        return wearables;
    }
    getBuddieTagList(){
        if (this.state.hubPopupDataNote.json.toddles 
            && this.state.hubPopupDataNote.json.toddles>0){
            return this.state.hubPopupDataNote.json.toddles;
        }
        else if(this.state.hubPopupDataNote.json.buddies){
            return this.state.hubPopupDataNote.json.buddies;
        } else {
            return [];
        }
    }    
    makeWearableScript(wearables, scriptArray, filePrefix,wearableTypeInt){
        let result='url=localhost\n'
        //result+='namePrefix=\n';
        result+='port=3000\n';
        let iPos=0;
        let types=['headset','toddle','bracelet'];
        wearables.forEach( wearableTypeArray =>{
            result +=`echo \n`;
            result +=`echo processing ${types[iPos]}\n`;
            result +=`echo ---------------\n`;
            wearableTypeArray.forEach( wearable =>{
                //let wearableType=types[iPos];
                let url="http://$url:$port/api/";
                console.log(scriptArray[iPos]);
                let line=eval("`"+scriptArray[iPos]+"`");
                line=line.replaceAll('&quot;','\\"')
                result+=line+"\n";
            })
            iPos++;
        })
        console.log(result);
        let type="all";
        if(wearableTypeInt!==undefined){
            type=types[wearableTypeInt];
        }
        functions.downloadFile(filePrefix+"-"+type+"-"+this.state.hub.hostname+"-", result, 'txt');
    }
    execHubScript(url){
        db.saveData( this.props.securityObject
            ,{}
            ,url
            , function(res){
                            window.alert(res);
            }
        );
    
//        window.open(this.props.securityObject.httpServer + url
//            ,'popUpWindow'
//            ,'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes'
//        );
    }
    execHubUpdateScript(){
        this.execHubScript(`api/kickOffHubSendDataProcessOnServer?hostname=${this.state.hub.hostname}`);
        functions.sleep(20000).then(() => { this.loadData(); });
    }
    ipLookup(){
        this.setState({
            factoryDevicesPopupVisible:true
        });
    }
    closeFactoryDevicesPopup(rowData){
        this.setState({
            factoryDevicesPopupVisible:false
        });
        if(rowData){
            ///alert(JSON.stringify(rowData))
            document.getElementById("inputprocessor_ip_address").value=rowData.ip;
            let hubPopupPost=this.state.hubPopupPost;
            hubPopupPost["processor_ip_address"] = rowData.ip;         
            this.setState({
                hubId:true,
                hubPopupPost:hubPopupPost,
                hubPopupModified:true
            });   
            //evt.currentTarget.value
            //this.updateHubInputValue({currentTarget:{value:rowData.ip, name:"processor_ip_address"}});
        }
    }
    hubIPSelected(){
        this.setState({
            factoryDevicesPopupVisible:false
        });
    }
    viewFacility(){
        if(this.state.hub){
            this.setState({
                facilityPopupId:this.state.hub.facility_id
            })
        }
    }
    closeFacilityPopup(){
        this.setState({
            facilityPopupId:undefined
        })
    }
    moveFacility(rowData){
        //alert(JSON.stringify(rowData));
        this.moveCurrentFacility(rowData.id,rowData.facility_name)
    }
    toggleinputcell_wifi_facility_password(){
        let obj=document.getElementById("inputcell_wifi_facility_password");
        if(obj.type=="password"){
            obj.type="text";
        } else {
            obj.type="password";
        }
    }
    decodeinputcell_wifi_facility_password(){
        let obj=document.getElementById("inputcell_wifi_facility_password");
        db.saveData( this.props.securityObject
            , { "cell_wifi_facility_password":obj.value}
            ,"api/getDecryptedPassword"
            , function(res){
                    if(res.resultCode===1){
                        obj.value=res.cell_wifi_facility_password
                    } else {
                        window.alert(JSON.stringify(res));
                    }
                }
        );        
    }    
} 
function clickUpdateButton(evt){
    let successDisplay="";
    let obj={ hub_id:this.state.hub.id
                , hub_update_id:evt.currentTarget.name};
    let button=evt.currentTarget;
    if(button.innerHTML==="x"){
        successDisplay="_";
        obj.add=false;
    } else {
        successDisplay="x";
        obj.add=true;
    }
    //window.alert(JSON.stringify(obj));
    db.saveData( this.props.securityObject
        , obj
        ,"api/updateHubUpdate"
        , function(res){
                            if(res.resultCode===1){
                                button.innerHTML=successDisplay;
                            } else {
                                window.alert(JSON.stringify(res));
                            }
                        }
    );
}
